import React, { useCallback, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Icon from '../../atoms/icon/Icon'
import Table from '../../atoms/table/Table'
import API from '../../../services/api'

import StickyBar from '../../organisms/sticky-bar/StickyBar'
import EmptyList from '../../organisms/empty-list/EmptyList'
import IconButton from '../../molecules/iconbutton/IconButton'
import Clickable from '../../atoms/clickable/Clickable'
import DeleteAssessment from './AssessmentDelete'
import ClientAvatarList from '../../molecules/client-avatar-list/ClientAvatarList'
import { CloneAssessment } from './actions/CloneAssessment'

interface Props {
  assessments: API.AssessmentResponse[]
  refreshAssessments: () => void
}

interface AssessmentState {
  deleteModalOpen: boolean
  assessmentSelected: API.AssessmentResponse | null
}

const STICKY_BAR_HEIGHT = 8

function AssessmentListTable({ assessments, refreshAssessments }: Props) {
  const history = useHistory()
  const [{ deleteModalOpen, assessmentSelected }, setAssessmentState] = useState<AssessmentState>({ deleteModalOpen: false, assessmentSelected: null })

  const onAssessmentDeleteComplete = useCallback(() => {
    setAssessmentState(prevState => ({ ...prevState, deleteModalOpen: false, assessmentSelected: null }))
    refreshAssessments()
  }, [refreshAssessments])

  return (
    <>
      {deleteModalOpen && !!assessmentSelected && <DeleteAssessment
        isOpen={deleteModalOpen}
        onClose={() => setAssessmentState(prevState => ({ ...prevState, assessmentModalOpen: false, assessmentSelected: null }))}
        onComplete={onAssessmentDeleteComplete}
        assessment={assessmentSelected}
      />}
      <StickyBar height={STICKY_BAR_HEIGHT}>
        <IconButton data-test='add-assessment' linkTo='/assessments/add' icon='assessments' text='Add New Assessment' />
      </StickyBar>
      {!assessments.length && <EmptyList icon='assessments' message='There are no assessments yet' />}
      {!!assessments.length &&
        <Table stickyHeader stickyTop={STICKY_BAR_HEIGHT} clickable>
          <thead>
            <tr>
              <th>Assessment Name</th>
              <th>Clients</th>
              <th className='right'>Actions</th>
            </tr>
          </thead>
          <tbody>
            {assessments.map(assessment => (
              <tr className='assessmentsTable-row' key={assessment.id} data-test={assessment.id} onClick={(event) => {
                event.stopPropagation()
                event.preventDefault()
                history.push(`/assessments/${assessment.id}/view`)
              }}>
                <td>{assessment.name}</td>
                <td><ClientAvatarList clients={assessment.clients} /></td>
                <td className='right'>
                  <CloneAssessment
                    type='icon'
                    assessment={assessment}
                  />
                  <Icon type='search' tip={{ content: 'View Assessment', id: `${assessment.id}-view` }} />
                  {assessment && <Clickable
                    data-test={`delete-${assessment.id}`}
                    onClick={(event) => {
                      event.stopPropagation()
                      setAssessmentState({ deleteModalOpen: true, assessmentSelected: assessment })
                    }}>
                    <Icon
                      type='trash'
                      tip={{
                        content: 'Delete assessment',
                        id: `${assessment.id}-delete`
                      }}
                    />
                  </Clickable>}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      }
    </>
  )
}

export default AssessmentListTable
